
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.498","height":"19.498","viewBox":"0 0 19.498 19.498"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/clipboard-text"}},[_c('path',{attrs:{"d":"M6.499 9.911h5.687","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M6.499 13.161h3.558","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M8.124 4.875h3.25c1.625 0 1.625-.813 1.625-1.625 0-1.625-.813-1.625-1.626-1.625H8.124c-.813 0-1.625 0-1.625 1.625s.812 1.625 1.625 1.625z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M12.998 3.266c2.705.146 4.062 1.145 4.062 4.858v4.875c0 3.25-.812 4.874-4.874 4.874H7.311c-4.062 0-4.874-1.625-4.874-4.874V8.124c0-3.704 1.357-4.712 4.062-4.858"}})])])
          )
        }
      }
    